// /privacy — STRUCTURED PLACEHOLDER, same rule as Terms.jsx: the section list
// is right, the wording is a draft and the page says so on its face. What it
// describes is nonetheless the product's real behaviour (records belong to the
// establishment that wrote them, linking needs consent, changes are audited),
// so a reviewer is editing wording rather than correcting facts.

import { useTranslation } from 'react-i18next';
import PublicPage, { Section } from './PublicPage';

const CLAUSES = [1, 2, 3, 4, 5, 6];

export default function Privacy() {
  const { t } = useTranslation('publicPages');
  return (
    <PublicPage
      testId="privacy-page"
      title={t('publicPages.privacy_title')}
      lead={t('publicPages.privacy_lead')}
      note={t('publicPages.draft_note')}
    >
      {CLAUSES.map((n) => (
        <Section key={n} heading={t(`publicPages.privacy_h${n}`)} testId={`privacy-clause-${n}`}>
          <p>{t(`publicPages.privacy_p${n}`)}</p>
        </Section>
      ))}
    </PublicPage>
  );
}
